import { Injectable } from '@angular/core';
import { EventManagerService } from '../event-manager/event-manager.service';

/**
 * Leitet aus den granularen `RAGAI.MSG.*`-Events abgeleitete Flow-Meilensteine ab (`RAGAI.FLOW.firstUserMessage`,
 * `.firstBotResponse`, `.requestStart`, `.requestComplete`).
 * @remarks
 * Erzeugt selbst **keine** neue Funktionalität, sondern nur bequemere, höher-levelige Event-Namen über
 * `RAGAI.EVENTS` - wer ohnehin auf `RAGAI.MSG.prompt`/`runComplete` lauscht, braucht dieses Modul nicht.
 * Feuert bewusst erst per `queueMicrotask` **nach** dem auslösenden granularen Event, damit alle Listener des
 * granularen Events (z. B. Blockly-"bei Ereignis"-Bausteine) unabhängig von ihrer Registrierungsreihenfolge
 * zuerst vollständig durchgelaufen sind, bevor der abgeleitete Flow-Meilenstein feuert.
 * `firstUserMessage`/`firstBotResponse` feuern jeweils nur **einmal** pro Sitzung; `requestStart`/`requestComplete`
 * dagegen bei **jeder** Anfrage-Antwort-Runde.
 */
@Injectable({
  providedIn: 'root'
})
export class FlowManagerService {

  private firedFirstUserMessage = false;
  private firedFirstBotResponse = false;

  constructor(private eventManager: EventManagerService) {
    this.eventManager.on('RAGAI.MSG.userMessage', (_hook: string, params: unknown) => {
      if (this.firedFirstUserMessage) return;
      this.firedFirstUserMessage = true;
      queueMicrotask(() => this.eventManager._trigger_RAGAI_EVENT('RAGAI.FLOW.firstUserMessage', params));
    });

    this.eventManager.on('RAGAI.MSG.runComplete', (_hook: string, params: unknown) => {
      if (this.firedFirstBotResponse) return;
      this.firedFirstBotResponse = true;
      queueMicrotask(() => this.eventManager._trigger_RAGAI_EVENT('RAGAI.FLOW.firstBotResponse', params));
    });

    // RAGAI.MSG.prompt / RAGAI.MSG.runComplete klammern jede einzelne
    // Anfrage-Antwort-Runde ein (nicht nur die erste) und werden deshalb
    // zusätzlich zu jedem Vorkommen als eigene Flow-Meilensteine gespiegelt.
    this.eventManager.on('RAGAI.MSG.prompt', (_hook: string, params: unknown) => {
      queueMicrotask(() => this.eventManager._trigger_RAGAI_EVENT('RAGAI.FLOW.requestStart', params));
    });

    this.eventManager.on('RAGAI.MSG.runComplete', (_hook: string, params: unknown) => {
      queueMicrotask(() => this.eventManager._trigger_RAGAI_EVENT('RAGAI.FLOW.requestComplete', params));
    });
  }
}
